import ThemeImage from "@/components/ThemeImage";
import serverSpeedDark from "@/assets/server-speed-dark.webp";
import serverSpeedLight from "@/assets/server-speed-light.webp";

const BuiltFastSection = () => {
  return (
    <section className="py-20 border-t border-border" aria-labelledby="built-fast-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in flex justify-center lg:justify-start">
            <ThemeImage
              darkSrc={serverSpeedDark}
              lightSrc={serverSpeedLight}
              alt="High-speed server infrastructure"
              className="w-full max-w-lg rounded-2xl mx-auto lg:mx-0"
              width={512}
              height={340}
            />
          </div>
          <div className="animate-fade-in">
            <h2 id="built-fast-title" className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Built Fast. Built Right. Built to Convert.
            </h2>
            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed">
              <p>
                Modern frameworks and a streamlined process get you live in 3-7 days—without
                sacrificing quality or performance.
              </p>
              <p>
                Work directly with the builder. No account managers, no delays—just fast iteration
                and sites that load instantly, work flawlessly, and convert.
              </p>
              <p>
                We don't just build websites. We build growth engines that work 24/7.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltFastSection;
